import { ShiftHours } from '@bemlo/enums'

import { Color } from '../../../constants'
import { DayCellStyles } from '../atoms/types'
import { AvailabilityScope } from '../types'

export const EMPTY_ARRAY: [] = []
Object.freeze(EMPTY_ARRAY)

export const ALL_AVAILABILITY_SHIFT_HOURS = [
  ShiftHours.DAY,
  ShiftHours.EVENING,
  ShiftHours.NIGHT,
]
Object.freeze(ALL_AVAILABILITY_SHIFT_HOURS)
// Monday to Sunday
// TODO: We might want to adapt for locale later

export const WEEK_DAY_INDICES: ReadonlyArray<number> = [0, 1, 2, 3, 4, 5, 6]
Object.freeze(WEEK_DAY_INDICES)

export const EMPTY_SCOPE: AvailabilityScope = {
  scope: 0,
  shiftHours: EMPTY_ARRAY,
}
Object.freeze(EMPTY_SCOPE)

export const DISABLED_DAY_STYLE: DayCellStyles = {
  backgroundColor: Color.DARK_MEDIUM_GREY,
  color: Color.DARKEST_MEDIUM_GREY,
} as const

export const VIEW_TENDERED_DAY_STYLE: DayCellStyles = {
  backgroundColor: Color.WHITE,
  color: Color.DARK_GREY,
} as const
Object.freeze(VIEW_TENDERED_DAY_STYLE)

export const VIEW_PRESENTED_DAY_STYLE: DayCellStyles = {
  backgroundColor: Color.WHITE,
  color: Color.DARKER_GREY,
} as const

export const ACCEPTED_DAY_STYLE: DayCellStyles = {
  backgroundColor: Color.GREEN,
  color: Color.WHITE,
  icon: {
    name: 'CheckCircleIcon',
    design: 'solid',
  },
} as const
Object.freeze(ACCEPTED_DAY_STYLE)

export const REJECTED_DAY_STYLE: DayCellStyles = {
  backgroundColor: Color.RED,
  color: Color.WHITE,
  icon: {
    name: 'XCircleIcon',
    design: 'outline',
  },
} as const

export const BOOKED_DAY_STYLE = ACCEPTED_DAY_STYLE
Object.freeze(BOOKED_DAY_STYLE)
